import { Component, OnInit } from '@angular/core';
import 'rxjs';
declare var $:any;

@Component({
  selector: 'app-take-our',
  templateUrl: './take-our.component.html',
  styleUrls: ['./take-our.component.scss']
})
export class TakeOurComponent implements OnInit {

  public TakeOurs = [
    {
      name:'B Brown.',
      summary: 'I have farmed foreclosures for most of my real estate career and I have found my lead data the hard way. ReboGateway helps me search for many types of leads easily and allow me to send mailings. Best product I have used to grow my business.'
    },
    {
      name:'D Anderson.',
      summary: 'With turn over and life events this is a great product and I have many clients that will appreciate the timely information they will be receiving on their farms. Keep up the good work!'
    },
    {
      name:'Brian P.',
      summary: 'This tool helps me create a method to stay ahead of the competition. Real steps anyone can take to increase your client-base, build a successful business and increase your income.'
    },
    {
      name:'K Collins.',
      summary: 'I think these guys have a great product and the pricing is awesome. No sales pressure either. All around good people running a good company.'
    },
    {
      name:'G Ramirez.',
      summary: 'I recently bought rebogateway.com and can already see the amazing potential it has to offer me as a real estate investor. I requested a 1-on-1 coaching session and got it setup and done the same day. Awesome!'
    },
    {
      name:'D Wells.',
      summary: 'This system is awesome. However, you must take the training and play around with it. Once you get the hang of it, it will be your best friend in making those deals close with ease, not to mention John is great!'
    },
    {
      name:'L Smith.',
      summary: 'This is a great tool. I am so pleased my Title Rep set this up. The Instructor was terrific. Went over the parts I was unsure of and even gave me tips for better marketing. I love this program and it is ease of use. Everyone should have this tool box.'
    },
    {
      name:'Alison F.',
      summary: 'I love what ReboGateway can do. So far, as you can guess from the title, the service has been phenomenal too. The data it spits out is unmatched to anything else we have spent time with so far! Thank you and keep up the good work!!'
    },
    {
      name:'Gloria G.',
      summary: 'I was looking for something more precise to get leads. This is exactly what I have been looking for. I am able to customize my farm and pinpoint likely clients. I get great leads that keep me busy. I also am impressed with their support. They really try to help you and make you successful! It\'s a win-win for all. If u r on the fence, this will give the boost to your business that u are looking for. It takes a lot of the random marketing out of the picture to focus on the real prospective clients'
    },
    {
      name:'G Manners.',
      summary: 'Since joining ReboGateway some time ago I’ve always received the help I need, whether for an individual question or for another comprehensive review. These days I find I must market to more territory to get the same results that I used to get. It\'s too expensive to do that effectively. I realized I have to target to the most likely potential sellers in order to meet my goals. ReboGateway has the data necessary to do that. And it’s more comprehensive and less expensive than other sources.'
    },
    {
      name:'E Howard.',
      summary: 'Great tools for Realtors are hard to find. Even harder to find those with automated features. ReboGateway has allowed us to leverage our time to maximize our results. Finally we can focus on specific markets instead of the shotgun approach.'
    },
    {
      name:'Warren D.',
      summary: 'I Love the website with all that it has to offer, no Real Estate Agent should be without this site , if they want to make money , sometimes as agent we hesitate to purchase things thinking that its a scam, But I am here to tell you that this web site has so many tools to select from , if you wan to grow your business , don\'t wait, I have been with the same office for 19 yrs., wish I would have found this sooner, GOOD LUCK'
    },
    {
      name:'Diane S.',
      summary: 'As an assistant to a Top Producing Real Estate Agent, I have found Benutech/ReboGateway to be excellent on all levels. The program is working well to help us target our marketing and the support staff is excellent.'
    },
    {
      name:'Marco M.',
      summary: 'I am surprised at how I have been able to change the way I do business using ReboGateway from Benutech. I am now able to predict which homeowners are more likely to sell due to divorces, NODs or deaths in the family. Now if I can only keep my competitors from finding out about this service...'
    },
    {
      name:'Brian P.',
      summary: 'This is a quality service that does exactly what it says it will do and does it well! Tech support is readily available to make sure you get the maximum benefit from their services.'
    },
    {
      name:'Tim T.',
      summary: 'As a Realtor I get contacted constantly with offers & solicitations from every company under the sun that wants me to start paying them out of my hard earned commissions. Zillow/Trulia, Realtor.com, Google Analytics, multiple SEO companies all want me to spend for their leads & services. Brian & Patrick J. at Benutech set up a private demo of their ReboGateway platform that was purely inspriring. I will certainly budget the dollars to subscribe & make full use of this quality tool shortly !! '
    },
    {
      name:'J Wells.',
      summary: 'I am completely satisfied with Benutech. They are responsive to answering questions and provide everything needed to work their platform Rebogateway. It is an excellent choice for lead generation and mail out campaigns. I am most sold by the training they provide that\'s included with your subscription. They provide 1 on 1 training and provide an hour and half training program to show you how to navigate and work the options of Rebogateway. Love it so far and highly recommend it.'
    },
    {
      name:'J Greer.',
      summary: 'It is awesome....I can not say enough about how well Rebogateway tailored to the needs of the real estate industry. I am happy to be using the software with varies degree of satisfaction. Thanks for a great tool!'
    },
    {
      name:'Kelli H.',
      summary: 'I am so pleased with my Benutech experience. I have received personalized care and assistance since day-one. This company and its staff are a "highly-recommend" for sure.'
    },
    {
      name:'Anwar A.',
      summary: 'This company is a godsend, it makes my life as an investor so much easier! The training they provide is top notice and the trainers are always there to assist'
    },
    {
      name:'A Negri.',
      summary: 'This is and easy to use tool that saves me a ton of money when purchasing lists. The cost saving are unbelievable and the customer service is better than the product'
    },
    {
      name:'R Nickel.',
      summary: 'The quality of highly targeted and highly motivated leads is incredible. This has been some of the best marketing money invested in a long time.'
    },
    {
      name:'M Moore.',
      summary: 'This is really cool! I wish they had something like this when I was getting started in Real Estate. It makes it so easy to farm an area and what great info you get at a very inexpensive price.'
    },
    {
      name:'A Syed.',
      summary: 'Once in a while you come across a company that delivers more than it promises. Benutech is one such company. Their products are worth their weight in gold. I have just started to use their site, but I can see where I am headed. The same information from other companies comes with an atrocious price tag. As for their service it is truly exemplary. The trainers are knowledgeable and reach out to you immediately. I highly recommend their service.'
    },
    {
      name:'Sharon W.',
      summary: 'ReboGateway is a time saving, valuable marketing tool which will positively effect your bottom line.'
    },
    {
      name:'J Simmons.',
      summary: 'Along with hardwork, this software is a key in a successful real estate career! Since getting started, the support team has been outstanding. I am looking forward to having a fully integrated marketing program. Thanks a bunch to the staff a Rebo Gateway. It is not just the product, but the people behind it that make it a great experience.'
    }
  ];

  ngAfterViewInit(){
    $('.take-our').slick({
      autoplay: false,
      dots: true,
      arrows: true
    });
  }

  constructor() { }

  ngOnInit() {
  }

}



// WEBPACK FOOTER //
// /Users/muhammadfarhan/Documents/benutech/benutechv2/client/src/app/shared/take-our/take-our.component.ts